// eslint-disable-next-line import/no-extraneous-dependencies
import { CountUp } from 'countup.js';

window.addEventListener( 'load', () => {
	counter();
} );

const counter = () => {
	const numbers = document.querySelectorAll( '.block-statistics__item-number' );

	const options = {
		separator: ' ',
		enableScrollSpy: true,
	};

	numbers.forEach( ( number ) => {
		const countUp = new CountUp( number, Number( number.dataset.id ), options );
		countUp.start();
	} );
};
